/* Claude models offered by the app. Client-side source of truth: the Tweaks
 * dropdown, the initial tweaks state, the proxy default, and realFill's default
 * all read from here.
 *
 * The Azure Function keeps its own allowlist (api/src/functions/claude.js) —
 * it is a separate CommonJS package and cannot import from src/. Keep the two
 * in sync when adding or removing a model.
 */

export const MODELS = [
  { value: 'claude-sonnet-5', label: 'Sonnet 5 (default)' },
  { value: 'claude-opus-5', label: 'Opus 5 (highest quality)' },
  { value: 'claude-haiku-4-5', label: 'Haiku 4.5 (fast, cheapest)' },
];

export const DEFAULT_MODEL = 'claude-sonnet-5';
